<template>
  <div class="echart-box-cla">
    <div class="chart_title_cla">
      <div class="title-bg-cla"></div>
      <div class="title-Text-cla">{{ $t('dashboard.device') }}</div>
    </div>
    <div id="online_device_chart" class="echart-cla"></div>
    <div class="fgf-cla"></div>
  </div>
</template>

<script>
import { getOptionConfig } from './onlineDeviceChat.js'
import { getDevStateTotal } from '@/services/enterpriseDashboardApi.js'

var echarts = require('echarts')
export default {
  data() {
    return {
      barChart: null,
      category: [],
      barData: [],
      dataList: [],
      timeout: null,
      intervalMapBar: null
    }
  },
  mounted() {
    let _this = this
    this.getData()
    window.addEventListener('resize', this.resizeChart, true)
    this.intervalMapBar = setInterval(() => {
      _this.getData()
    }, 5000)
  },
  beforeDestroy() {
    if (this.intervalMapBar) {
      clearInterval(this.intervalMapBar)
    }
    if (this.barChart) {
      try {
        this.barChart.clear()
        this.barChart.dispose()
      } catch (error) {}
    }
    window.removeEventListener('resize', this.resizeChart, true)
  },
  methods: {
    resizeChart() {
      if (this.barChart) {
        this.debounce(this.barChart.resize, 200)
      }
    },
    debounce(func, wait) {
      let context = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    },
    getOption() {
      let lang = {
        title: this.$t('dashboard.device'),
        onlineDevice: this.$t('dashboard.onlineDevice'),
        offLineDevice: this.$t('dashboard.offLineDevice')
      }
      let option = getOptionConfig(this.barData, lang)
      this.renderChart(option)
    },
    renderChart(option) {
      if (!this.barChart) {
        this.barChart = echarts.init(
          document.getElementById('online_device_chart')
        )
      }
      this.barChart.setOption(option, true)
    },

    getData() {
      getDevStateTotal()
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.results
            let temp = []
            for (let key of Object.keys(result)) {
              if (key !== 'total') {
                temp.push(this.createObj(key, result[key]))
              }
            }
            this.barData = temp
            this.getOption()
          }
        })
        .catch(e => {})
    },
    createObj(Name, Value, Color = '') {
      let name = Name
      let value = Value
      let itemStyle = { color: '#000' }
      return { name, value, itemStyle }
    }
  }
}
</script>
<style scoped lang="less">
.fgf-cla {
  position: absolute;
  right: 30%;
  height: 40%;
  top: 40%;
  width: 1px;
  background-image: url('~~@/assets/new/dashboard/fgx.png');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/dashboard/onlineDeviceChat/onlineDeviceChat.vue